/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Plan_Edit_Move_DownInputs */

const en_us2_plan_edit_move_down = /** @type {(inputs: Plan_Edit_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.name} down`)
};

const pt_br2_plan_edit_move_down = /** @type {(inputs: Plan_Edit_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover ${i?.name} para baixo`)
};

const es_419_plan_edit_move_down = /** @type {(inputs: Plan_Edit_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bajar ${i?.name}`)
};

const pt_pt2_plan_edit_move_down = /** @type {(inputs: Plan_Edit_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover ${i?.name} para baixo`)
};

const fr_fr2_plan_edit_move_down = /** @type {(inputs: Plan_Edit_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descendre ${i?.name}`)
};

const de_de2_plan_edit_move_down = /** @type {(inputs: Plan_Edit_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nach unten verschieben`)
};

const it_it2_plan_edit_move_down = /** @type {(inputs: Plan_Edit_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sposta ${i?.name} in giù`)
};

/**
* | output |
* | --- |
* | "Move {name} down" |
*
* @param {Plan_Edit_Move_DownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_move_down = /** @type {((inputs: Plan_Edit_Move_DownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Move_DownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_move_down(inputs)
	if (locale === "es-419") return es_419_plan_edit_move_down(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_move_down(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_move_down(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_move_down(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_move_down(inputs)
	return en_us2_plan_edit_move_down(inputs)
});
export { plan_edit_move_down as "plan-edit.move_down" }